import { Entity } from '@backstage/catalog-model';

export const isEntity = (value: unknown): value is Entity =>
  value !== null &&
  typeof value === 'object' &&
  'kind' in value &&
  'metadata' in value &&
  value.metadata != null &&
  typeof value.metadata === 'object' &&
  'name' in value.metadata;
